import { defineRouter } from '#q-app/wrappers'
import { createRouter, createMemoryHistory, createWebHistory, createWebHashHistory } from 'vue-router'
import {loggerFactory} from '../logger'
import routes from './routes'
import {page} from "src/rum";

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */
const logger = loggerFactory("Router")
export default defineRouter(function (/* { store, ssrContext } */) {
  const createHistory = process.env.SERVER
    ? createMemoryHistory
    : (process.env.VUE_ROUTER_MODE === 'history' ? createWebHistory : createWebHashHistory)

  const router = createRouter({
    scrollBehavior: () => ({ left: 0, top: 0 }),
    routes,

    // Leave this as is and make changes in quasar.conf.js instead!
    // quasar.conf.js -> build -> vueRouterMode
    // quasar.conf.js -> build -> publicPath
    history: createHistory(process.env.VUE_ROUTER_BASE)
  })

  // Add error handling for chunk loading failures
  router.onError((error) => {
    if (error.name === 'ChunkLoadError' ||
        error.message.includes('Loading chunk') ||
        error.message.includes('Invalid character')) {
      logger.error('Chunk loading error detected, attempting to reload:', error);

      // Check if we're on a route that uses dynamic imports
      const currentRoute = router.currentRoute.value;
      if (currentRoute && currentRoute.path.startsWith('/auth')) {
        // For auth routes, try to reload the page as a fallback
        window.location.reload();
      }
    }
  });

  router.afterEach((to, from) => {
    page(to.name)
  });

  return router
})
